import React from 'react'
import { ButtonOutline } from '../../../components'

const FileUploader = ({inputTrigger, noDefaultFile = false}) => {
  const [files, setFiles] = React.useState([])
  const fileInput = React.useRef()

  const handleChange = (e) => {
    const cloned = JSON.parse(JSON.stringify(files))
    const filename = e.target.files[0].name
    cloned.push(filename)
    setFiles(cloned)
  }

  return (
    <div>
      {
        !noDefaultFile &&
        <div className="flex items-center justify-between mb-8">
          <p className="font-bold text-primary underline mr-4 text-sm">Laporan-program-frosh.pdf</p>
          <p className="text-xs text-gray-999 underline">Delete</p>
        </div>
      }
      {
        files.map((f, i) => (
          <div className="flex items-center justify-between mb-8" key={i}>
            <p className="font-bold text-primary underline mr-4 text-sm">{f}</p>
            <p className="text-xs text-gray-999 underline">Delete</p>
          </div>
        ))
      }

      <input type="file" className="hide hidden" onChange={handleChange} ref={fileInput}/>

      <div
        className="border border-dashed rounded p-6 flex items-center justify-center cursor-pointer"
        style={{borderColor: '#ddd'}}
        onClick={() => fileInput.current.click()}
      >
        {
          inputTrigger !== 'button' &&
          <p className="text-gray-999 underline text-sm">Choose file</p>
        }
        {
          inputTrigger === 'button' &&
          <ButtonOutline style={{maxWidth: '160px'}}>Choose File</ButtonOutline>
        }
      </div>
    </div>
  )
}

export { FileUploader }